// extracted by mini-css-extract-plugin
export var label = "_hc-2";
export var slideContainer = "_hc-0";
export var slider = "_hc-1";